import { numericFormatter } from "react-number-format";

// Derives the decimal/thousands separators for a locale (e.g. "de" → ",", "."; "en" → ".", ","),
// used by DecimalTextField to format according to the active i18next language. Shared by both apps.
export function getLocaleSeparators(locale: string): { decimalSeparator: string; thousandSeparator: string } {
  const parts = new Intl.NumberFormat(locale).formatToParts(1234.5);
  return {
    decimalSeparator: parts.find((p) => p.type === "decimal")?.value ?? ".",
    thousandSeparator: parts.find((p) => p.type === "group")?.value ?? ",",
  };
}

// Formats a number with fixed decimals using the locale's separators (e.g. 1234.5 → "1.234,50" for
// "de"). Moved from the internal app's utils/formatNumber so the shared client-file areas can use it.
export function formatDecimal(value: number, locale: string, decimalScale = 2): string {
  const { decimalSeparator, thousandSeparator } = getLocaleSeparators(locale);
  return numericFormatter(String(value), {
    decimalScale,
    fixedDecimalScale: true,
    decimalSeparator,
    thousandSeparator,
  });
}

/** A monetary amount followed by the Euro sign, e.g. "1.480,50 €". */
export function formatEuro(value: number, locale: string): string {
  return `${formatDecimal(value, locale)} €`;
}

/** A whole number grouped per the locale's convention, e.g. 1234 → "1.234" for "de". */
export function formatInteger(value: number, locale: string): string {
  return new Intl.NumberFormat(locale).format(value);
}
